enum PaymentTypeEnum {
	BillingPeriod = 'billingPeriod',
	OneOffPayment = 'oneOffPayment',
}

export default PaymentTypeEnum;
